import type { FrameLayout } from './sceneState.js';

export type LayoutDirection = 'row' | 'column' | 'stack' | null;

export function frameLayoutDirection(layout: FrameLayout): LayoutDirection {
  return layout.kind === 'free' ? null : layout.kind;
}
